<template>
  <div class="chat-configure-form mt-4">
    <div
      class="Polaris-InlineGrid"
      style="--pc-inline-grid-grid-template-columns-xs:minmax(0, 1fr);--pc-inline-grid-grid-template-columns-md:minmax(0, 2fr) minmax(0, 1fr);--pc-inline-grid-gap-xs:var(--p-space-400)"
    >
      <!-- Left column: Configuration options -->
      <div style="display:inherit;width:auto;border-inline-start:none">
        <div
          class="Polaris-InlineStack"
          style="--pc-inline-stack-align:center;--pc-inline-stack-wrap:wrap;--pc-inline-stack-gap-xs:var(--p-space-400);--pc-inline-stack-flex-direction-xs:row"
        >
          <div style="color:var(--p-color-text-info-on-bg-fill);width:100%">
            <div class="Polaris-LegacyCard">
              <!-- Hide URLs Section Content -->
              <div class="p-5">
                <div class="mb-4">
                  <h2 class="Polaris-Text--root Polaris-Text--headingMd">
                    Hide Chat button On Urls
                  </h2>

                  <p class="mt-1 text-sm leading-5 text-gray-500">
                    Chat button will be hidden in the configured urls.
                  </p>
                </div>

                <div class="border-b border-gray-200 pb-4 mb-4">
                  <div class="flex items-center">
                    <h4 class="text-base font-medium text-gray-700 mr-2">
                      Enable
                    </h4>
                    <div class="mt-1">
                      <VSwitch v-model="config.hideButtonUrls.isEnabled" />
                    </div>
                  </div>
                </div>

                <div>
                  <h4 class="text-base font-medium text-gray-700 mb-4">URL</h4>

                  <div class="space-y-3">
                    <div
                      v-for="(url, index) of config.hideButtonUrls.urls"
                      :key="index"
                      class="flex items-center"
                    >
                      <div class="flex-grow relative">
                        <input
                          class="w-full border border-gray-300 rounded-md py-2 px-3 text-sm shadow-sm focus:outline-none focus:ring-1 focus:ring-blue-500 focus:border-blue-500"
                          :value="url"
                          @input="updateUrl(index, $event)"
                          type="text"
                        />
                      </div>
                      <button
                        type="button"
                        @click="deleteUrl(index)"
                        class="ml-2 text-gray-500 hover:text-gray-700"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          class="h-5 w-5"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 012 0v6a1 1 0 11-2 0V8zm5-1a1 1 0 00-1 1v6a1 1 0 102 0V8a1 1 0 00-1-1z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <button
                    type="button"
                    @click="addUrl"
                    class="mt-4 inline-flex items-center text-sm font-medium text-gray-700"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 mr-1"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M10 5a1 1 0 011 1v3h3a1 1 0 110 2h-3v3a1 1 0 11-2 0v-3H6a1 1 0 110-2h3V6a1 1 0 011-1z"
                        clip-rule="evenodd"
                      />
                    </svg>
                    Add URL
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right column placeholder to maintain grid layout -->
      <div></div>
    </div>
  </div>
</template>

<script>
import VSwitch from "../../components/Common/VSwitch";

export default {
  components: {
    VSwitch
  },
  model: {
    prop: "config",
    event: "change"
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    save() {
      this.$emit("save");
    },
    addUrl() {
      this.config.hideButtonUrls.urls.push("");
    },
    deleteUrl(index) {
      this.config.hideButtonUrls.urls.splice(index, 1);
    },
    updateUrl(index, event) {
      this.config.hideButtonUrls.urls[index] = event.target.value;
      this.$set(this.config.hideButtonUrls.urls, index, event.target.value);
      // this.$emit("value", this.config);
    }
  }
};
</script>

<style lang="scss" scoped>
.chat-configure-form .Polaris-LegacyCard {
  overflow: visible;
}

.chat-configure-form .Polaris-Connected__Item--primary {
  z-index: unset;
  position: unset;
}

.chat-configure-form .Polaris-Connected__Item--primary:focus {
  z-index: 10000;
}
</style>
